import type { OrganizationInvitationResponse } from "@kontextwerk/control-web-client"
import type { MembershipInvitationsApi } from "../../../../../../../../../../../../../api/kehrblatt/membership-invitations"
import {
  runConfirmedChange,
  type ConfirmedChangeOutcome,
} from "../../../../../../../_shared/_logic/confirmed-change"
import { invitationExpiresAt } from "../../../_shared/_logic/invitation-lifetime"
import type { UserDataStepOutput } from "../_shared/_logic/user-create-workflow"

export type IssueInvitationCommand = Readonly<{
  api: MembershipInvitationsApi
  userData: UserDataStepOutput
  now?: number
}>

export type IssueInvitationResult = ConfirmedChangeOutcome<OrganizationInvitationResponse>

/** Issues one invitation with the chosen role; the server sends the e-mail with the link. */
export const issueInvitation = ({
  api,
  userData,
  now = Date.now(),
}: IssueInvitationCommand): Promise<IssueInvitationResult> =>
  runConfirmedChange(
    {
      title: "Benutzer einladen",
      description: `Die Einladung an ${userData.email} wird versendet. Bitte bestätigen Sie die Aktion mit Ihrem aktuellen Passwort.`,
      actionLabel: "Einladen",
      preserveParent: true,
    },
    () =>
      api.issue({
        recipient_email: userData.email,
        role_id: userData.role.id,
        expires_at: invitationExpiresAt(now),
      }),
  )
